import { useTranslation } from 'react-i18next';
import { ActionType } from '@electricjs/core_entity-client';
import { FilterOption } from 'common/TableFilters/types';
import { EventTypeMap } from '@/components/Assets/AssetEventsHistory/types';
import { Flex, spaces } from '@electricjs/arc';
import SearchableListFilter from 'common/TableFilters/SearchableListFilter';
import SelectChip from 'common/TableFilters/SelectChip';
import { formatActionType } from '../helpers/formatAssetEventHistory';

export const EventOptions: FilterOption<ActionType>[] = Object.entries(
  EventTypeMap
).map(([key, value]) => ({
  id: key,
  value: key as ActionType,
  text: value,
}));

export const EventTypeFilter = ({
  eventTypes,
  handleAddEventType,
}: {
  eventTypes: ActionType[];
  handleAddEventType: (eventType: ActionType[]) => void;
}) => {
  const { t } = useTranslation('assets');
  const handleAddFilter = (eventType: ActionType) => {
    handleAddEventType([...eventTypes, eventType]);
  };
  const removeEventType = (eventType: ActionType) => {
    handleAddEventType(eventTypes.filter(s => s !== eventType));
  };

  const translatedEventTypeOptions = EventOptions.map(option => {
    const formattedOption = formatActionType(option.text);
    const formattedText = t(`eventsHistory.eventTypes.${formattedOption}`);
    return {
      ...option,
      text: formattedText,
    };
  });

  return (
    <Flex alignItems="center" gap={spaces.space_m_rem}>
      <SearchableListFilter
        options={translatedEventTypeOptions}
        selectedValues={eventTypes}
        onSelect={(value, alreadySelected) =>
          alreadySelected
            ? removeEventType(value as ActionType)
            : handleAddFilter(value as ActionType)
        }
        filterName={t('eventsHistory.filters.eventType')}
        placeholder={t('eventsHistory.filters.searchEventType')}
        emptyText={t('eventsHistory.filters.noEventTypesFound')}
        someOptionIsChecked={eventTypes.length > 0}
      />
      <SelectChip
        selectedValues={eventTypes}
        options={translatedEventTypeOptions}
        handleRemoveFilter={removeEventType}
      />
    </Flex>
  );
};
